import { render, staticRenderFns } from "./scanIntegralDetail.vue?vue&type=template&id=483ec0cd"
import script from "./scanIntegralDetail.vue?vue&type=script&lang=js"
export * from "./scanIntegralDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports